/* (c) Copyright Frontify Ltd., all rights reserved. */

import { MarkupElement } from '../../MarkupElement';

export class AlignCenterMarkupElement extends MarkupElement {
    constructor(id = 'align-center') {
        super(id);
    }
}
